var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 86,
    viewBox: "0 0 93 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6531 54.1214C87.5844 51.041 93.4708 8.20902 57.1585 1.67002C8.11202 -3.75601 3.02398 25.3237 1.35316 33.1255C-2.56589 72.4383 27.3167 80.8612 32.3484 82.0644C44.9883 85.087 61.8976 83.237 72.4243 75.0495C77.978 70.7301 84.5356 61.1254 86.6531 54.1214Z",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1057 1.31153C101.849 5.41622 91.3476 45.7119 90.0512 55.2469C85.8423 69.9389 81.376 71.8556 75.8224 76.1751C65.2956 84.3626 44.3663 86.1928 30.5645 81.5922",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0436 33.2153C57.0436 34.2208 54.8222 34.4788 54.6288 33.8021C54.2585 32.5058 57.7938 31.1638 57.856 32.7188C57.9102 34.0743 57.2112 35.2653 55.6444 34.8176C54.6423 34.5313 56.6374 32.3546 56.6374 34.434",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5086 31.5899C34.2498 31.5899 33.4877 30.8361 32.6651 29.965C31.6049 28.8424 33.6234 29.1526 34.2899 29.1526C36.3549 29.1526 35.7753 32.0045 34.0868 32.3797C33.4272 32.5263 32.2588 32.6358 32.2588 31.793C32.2588 30.7655 33.9553 31.1837 34.6962 31.1837C36.4656 31.1837 33.8837 34.1004 33.8837 30.7774",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5269 47.9883C54.7521 57.8098 45.4085 56.3179 40.7658 56.3179C34.7984 55.8206 23.4221 51.0964 22.3653 43.5127",
    stroke: "#954AF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.9fb38084aa4b8753a31d57c91155bbbc.svg";
export { ForwardRef as ReactComponent };